function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 3.5,
  stroke: "#222222",
  strokeOpacity: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.75 7.783C17.75 6.05 12.5885 6 12 6C11.4115 6 6.25 6.05 6.25 7.783C6.25257 7.84225 6.25943 7.90124 6.2705 7.9595C6.7 10.9595 7.458 15.943 7.837 16.5C8.216 17.057 9.2685 18 12 18C14.7315 18 15.781 17.059 16.163 16.5C16.545 15.941 17.3 10.9595 17.7295 7.9595C17.7406 7.90124 17.7474 7.84225 17.75 7.783ZM12 7C14.6115 7 16.3135 7.4705 16.7 7.783C16.314 8.0955 14.6125 8.567 12 8.567C9.3875 8.567 7.6865 8.0955 7.3 7.783C7.6865 7.4705 9.3885 7 12 7ZM9.7915 15.6225C9.77751 15.6232 9.76349 15.6232 9.7495 15.6225C9.65726 15.6225 9.56828 15.5884 9.49956 15.5269C9.43084 15.4654 9.38721 15.3807 9.377 15.289L8.877 10.789C8.86938 10.6918 8.89984 10.5955 8.96195 10.5204C9.02406 10.4452 9.11295 10.3972 9.20983 10.3864C9.30671 10.3757 9.40398 10.403 9.48108 10.4626C9.55819 10.5222 9.60908 10.6095 9.623 10.706L10.123 15.206C10.1288 15.2551 10.1248 15.3049 10.1112 15.3525C10.0976 15.4001 10.0748 15.4446 10.044 15.4833C10.0132 15.522 9.97498 15.5542 9.93165 15.5781C9.88832 15.602 9.84069 15.6171 9.7915 15.6225ZM12.375 15.5C12.375 15.5995 12.3355 15.6948 12.2652 15.7652C12.1948 15.8355 12.0995 15.875 12 15.875C11.9005 15.875 11.8052 15.8355 11.7348 15.7652C11.6645 15.6948 11.625 15.5995 11.625 15.5V11C11.625 10.9005 11.6645 10.8052 11.7348 10.7348C11.8052 10.6645 11.9005 10.625 12 10.625C12.0995 10.625 12.1948 10.6645 12.2652 10.7348C12.3355 10.8052 12.375 10.9005 12.375 11V15.5ZM14.625 15.2915C14.6148 15.3832 14.5712 15.4679 14.5024 15.5294C14.4337 15.5909 14.3447 15.625 14.2525 15.625C14.2385 15.6257 14.2245 15.6257 14.2105 15.625C14.1615 15.6196 14.1141 15.6046 14.071 15.5808C14.0278 15.5571 13.9898 15.5251 13.959 15.4867C13.9282 15.4482 13.9053 15.4041 13.8916 15.3568C13.8779 15.3095 13.8736 15.26 13.879 15.211L14.379 10.711C14.3929 10.6145 14.4438 10.5272 14.5209 10.4676C14.598 10.408 14.6953 10.3807 14.7922 10.3914C14.889 10.4022 14.9779 10.4502 15.04 10.5254C15.1022 10.6005 15.1326 10.6968 15.125 10.794L14.625 15.2915Z",
  fill: "white"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6bd3ef5d.svg";
export { ForwardRef as ReactComponent };